var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound22BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 61",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 35.6,
  r: 11,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m44.85 13.68 7.07 7.07-5.318 6.383a2.5 2.5 0 0 1-3.689.167L38.3 22.687a2.5 2.5 0 0 1 .167-3.689l6.382-5.318Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m42.728 14.387.472-.158a2.813 2.813 0 0 1 2.878.68l4.613 4.613a2.813 2.813 0 0 1 .68 2.878l-.158.472"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m8.08 20.75 7.07-7.07 6.383 5.318a2.5 2.5 0 0 1 .167 3.689L17.087 27.3a2.5 2.5 0 0 1-3.689-.167L8.08 20.751Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8.787 22.872-.158-.472a2.812 2.812 0 0 1 .68-2.878l4.613-4.613a2.813 2.813 0 0 1 2.878-.68l.472.158"
})));
SvgRound22BError.viewBox = '0 0 60 61';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound22BError);
export default ForwardRef;